import en from './locale_en';
import tc from './locale_zh';
import sc from './locale_sc';

export default {'en-US': en, 'zh-HK': tc, 'zh-CN': sc};
